import { makeStyles } from '@material-ui/core/styles';

const tagNameStyles = makeStyles(() => ({
	span: {
		fontSize: '10px',
		color: '#6D6E71',
		backgroundColor: '#3333331a',
		borderRadius: '4px',
		width: '55px',
		overflow: 'hidden',
		whiteSpace: 'nowrap',
		verticalAlign: 'text-top',
		marginLeft: '8px',
		padding: '0 4px'
	}
}));

export default tagNameStyles;
